import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Overview from "@/pages/Overview";
import Fuel from "@/pages/Fuel";
import Cards from "@/pages/Cards";
import Loans from "@/pages/Loans";
import CalendarPage from "@/pages/CalendarPage";
import Roadmap from "@/pages/Roadmap";
import MonthlyPlan from "@/pages/MonthlyPlan";
import Users from "@/pages/Users";
import Assistant from "@/pages/Assistant";
import MailPage from "@/pages/Mail";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0D12]">
        <Loader2 className="w-8 h-8 animate-spin text-[#E65100]" />
      </div>
    );
  if (user === false) return <Navigate to="/giris" replace />;
  return children;
}

function AccessDenied() {
  return (
    <div className="p-8">
      <div className="card-surface p-10 text-center text-[#94A3B8] max-w-2xl mx-auto" data-testid="access-denied">
        Bu bölümü görüntüleme yetkiniz yok. Lütfen yöneticinizle iletişime geçin.
      </div>
    </div>
  );
}

function Guard({ module, admin, children }) {
  const { can, isAdmin } = useAuth();
  const ok = admin ? isAdmin : can(module, "view");
  if (!ok) return <AccessDenied />;
  return children;
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/giris" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Overview />} />
              <Route path="asistan" element={<Guard module="ai"><Assistant /></Guard>} />
              <Route path="yakit" element={<Guard module="aytemiz"><Fuel /></Guard>} />
              <Route path="kartlar" element={<Guard module="cards"><Cards /></Guard>} />
              <Route path="krediler" element={<Guard module="loans"><Loans /></Guard>} />
              <Route path="mailler" element={<Guard module="mail"><MailPage /></Guard>} />
              <Route path="aylik-plan" element={<MonthlyPlan />} />
              <Route path="takvim" element={<Guard module="calendar"><CalendarPage /></Guard>} />
              <Route path="kullanicilar" element={<Guard admin><Users /></Guard>} />
              <Route path="yol-haritasi" element={<Roadmap />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
